import { render, staticRenderFns } from "./visit_trend.vue?vue&type=template&id=61c25364&scoped=true"
import script from "./visit_trend.vue?vue&type=script&lang=js"
export * from "./visit_trend.vue?vue&type=script&lang=js"
import style0 from "./visit_trend.vue?vue&type=style&index=0&id=61c25364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c25364",
  null
  
)

export default component.exports